export default __webpack_public_path__ + "static/media/CreateCollab.40034f9f.jpg";